import { useContext } from "react";

import IncomingOrderMultiselectSelectionContext from "../context/IncomingOrderMultiselectSelectionContext";

const useIncomingOrderMultiselectSelection = () => useContext(IncomingOrderMultiselectSelectionContext);

export default useIncomingOrderMultiselectSelection;
